<template>
  <el-card class="container" :body-style="{padding: '0 8px 18px 8px'}">
    <div slot="header">
      <p class="title">{{$t('client.online_solutions.group_inquiry')}}</p>
      <div style="{margin-bottom: 4px}">{{from}} - {{to}}</div>
      <div>{{date}}</div>
    </div>
    <el-card v-for="service in services" :key="service.service.booking_code" style="margin: 10px 0 5px 0" :body-style="{padding: '0'}">
      <div style="padding: 4px;">
        <span>{{number(service.trains)}}</span>
        <div class="bottom">
          <p>{{service.offer.description}} - {{service.service.description}}</p>
          <p>{{departure(service.trains)|parseTime}} - {{arrival(service.trains)|parseTime}}</p>
          <span class="price"> {{service.service.price.cents|currency(service.service.price.currency)}}</span>
        </div>
      </div>
    </el-card>
    <div class="flex-row-left-align">
      <p class='control'>
        <el-input v-model="name" size="small" :placeholder="$t('client.online_solutions.contact_name')"></el-input>
      </p>
    </div>
    <div class='flex-row'>
      <p class='control'>
        <el-select v-model="passengers" filterable allow-create default-first-option name='passengers' v-validate="'required'" size="small" :placeholder="$t('client.online_solutions.group_size')">
          <el-option
            v-for="item in passengers_options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
        <el-alert v-if="errors.has('passengers')" :title="errors.first('passengers')" :closable="false" type="error"></el-alert>
      </p>
      <el-button type="primary" size="mini" :disabled="services.length === 0" @click="summit" class="summit"> {{$t('client.common.submit')}} </el-button>
    </div>
    <contact-submission :dialog-visible.sync="guestDialog.dialogVisible" :from="from" :to="to" :date="date" @submit-query="submitQuery"></contact-submission>
   </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import contactSubmission from '@/page/groupInquiry/contactSubmission'

export default {
  name: 'servicesCard',
  components: {
    contactSubmission
  },
  props: {
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    services: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      passengers: '',
      name: '',
      guestDialog: {
        dialogVisible: false
      }
    }
  },
  computed: {
    passengers_options () {
      return Array.from(Array(35), (_, x) => {
        const count = x + 10
        return {
          value: count,
          label: count + this.$t('client.common.passenger_unit')
        }
      })
    },
    ...mapGetters({ currentUser: 'currentUser' })
  },
  methods: {
    submitQuery () {
      const inquiryParams = {
        number_of_passengers: this.passengers,
        contact: { name: this.name },
        group_services: this.services.map(service => service.service.booking_code)
      }
      this.$http.post('/partner/vue_group_inquiries', inquiryParams)
        .then(response => {
          this.$router.push({path: '/group-inquiry', query: { async: response.data.async }})
        })
    },
    number (trains) {
      return trains[0] ? trains[0].number : ''
    },
    departure (trains) {
      return trains[0] ? trains[0].departure : ''
    },
    arrival (trains) {
      return trains[0] ? trains[0].arrival : ''
    },
    summit () {
      this.$validator.validateAll().then((validated) => {
        if (!validated) return
        if (this.currentUser.isGuest) {
          this.guestDialog.dialogVisible = true
        } else {
          this.submitQuery()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~Theme';
.container {
  font-size: 13px;
  padding: 0;
  background: rgb(238,238,238)
}
.title {
  font-size: 16px;
}
.bottom {
    margin-top: 13px;
    line-height: 12px;
    color: $--color-text-regular;
}
.passengers {
  width: 80px;
  margin: 5px 0;
}
.summit {
  margin: 5px 0;
  float: right;
}
.price {
  float: right;
  color: $--color-primary;
  margin-bottom: 4px;
}
i,.icon {
  float: right;
  margin-right: 4px;
}
.el-card /deep/ .el-card__header {
  padding: 10px;
  background-color: rgb(249,249,249);
}
.flex-row {
  display: -webkit-flex; /* Safari */
  display: flex;
  -webkit-justify-content: space-around; /* Safari */
  justify-content:         space-around;
  -webkit-align-items: flex-start; /* Safari */
  align-items:         flex-start;
  & .el-select {
    margin-top: 5px;
  }
}
.flex-row-left-align {
  display: -webkit-flex; /* Safari */
  display: flex;
  -webkit-justify-content: flex-start ; /* Safari */
  justify-content:         flex-start;
  -webkit-align-items: flex-start; /* Safari */
  align-items:         flex-start;
  
  & .el-input {
    margin-top: 5px; 
  }
}
.control {
  padding-right: 2px;
  display: -webkit-flex; /* Safari */
  display: flex; 
  -webkit-flex-direction: column;; /* Safari */
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/page/solutions/servicesCard.vue